import React, { Fragment } from 'react';
import { Empty } from 'antd';

const EmptyContent = () => {
    return (
        <Fragment>
            <h2 className="text-center regular-text">No hay información para esta solicitud</h2>
            <Empty />
        </Fragment>
    );
}

export default EmptyContent;